<div class="modal active">
  <div class="modal__container modal__container--sm">
        <div class="fields">
            <h2>{{modalTitle}}</h2>
            <div class="close" (click)="close()"><img src="/assets/img/close-white.svg" alt="" /></div>
            <div class="fields__container">
                <form autocomplete="off" class="active" #ngForm="ngForm">
                    <div class="fields__block">
                        <div class="fields__block__section">
                            <div class="input-fields">
                                <div *ngIf="isCalculationName == null;else calculationName">
                                  <label for="">{{inputLabel}}</label>
                                  <input name="name" type="text" [(ngModel)]="inputText"/>
                                </div>
                                <ng-template #calculationName>
                                  <label for="">{{inputLabel}}</label>
                                  <input name="name" type="text" [(ngModel)]="inputText"
                                  forbiddenSubstring={{forbiddenSubstringName}}  alphaNumeric #calculationName="ngModel"/>
                                  <span class="error" *ngIf="calculationName.errors?.forbiddenName">
                                    Name cannot contain {{forbiddenSubstringName}}.
                                  </span>
                                  <span class="error" *ngIf=" (calculationName.dirty || calculationName.touched) && calculationName.errors?.nonAlphaNumeric">
                                    Only alphanumeric characters, hyphens and underscores are allowed.
                                  </span>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                    <div class="fields__btn">
                      <button type="submit" [ngClass]="ngForm.valid? 'blue': 'gray'" [disabled]="!ngForm.valid" (click)="ok()">Ok</button>
                      <button type="button" class="gray" (click)="close()">Cancel</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
  </div>
